import {
  styled,
  TableHead,
  TableRow,
  Button,
  Box,
} from "@mui/material";

export const StyledTableHead = styled(TableHead)`
  .MuiTableCell-head {
    font-weight: bold;
  }
`;

export const StyledTableRow = styled(TableRow)<{
  $isParent?: boolean;
}>`
    background-color: ${(props) =>
            props.$isParent ? '#f5f5f5' : 'inherit'};
`;

export const StyledRowTitle = styled('span')<{
  $isParent: boolean;
}>`
  font-weight: ${(props) => (props.$isParent ? 'bold' : 'normal')};
  padding-left: ${(props) => (props.$isParent ? '12px' : '32px')};
`;

export const StyledSubmitButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'isDisabled'   // <-- prevent DOM warning
})<{ isDisabled?: boolean }>(({ theme, isDisabled }) => ({
  backgroundColor: isDisabled ? theme.palette.common.button.disabled : theme.palette.success.light,
  color: theme.palette.common.white,
  pointerEvents: isDisabled ? "none" : "auto",
  '&:hover': {
    backgroundColor: theme.palette.success.main,
  },
  marginTop: 20,
  marginBottom: 10,
  marginLeft: "auto",
}));

export const GlobalThreshContainer = styled("div")({
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
  width: "100%",
  height: "96%",
  gap: "16px",
});

export const TableContainerWrapper = styled("div")({
  width: "95%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  paddingLeft: "1%",
});

export const StyledTableFooter = styled(Box)({
  width: "100%",
  position: "relative",
  display: "flex",
  alignItems: "center",
  gap: "16px",
});